<template>
  <div class="launch-container">
    <!-- 装饰元素 -->
    <div class="deco-circle deco-1"></div>
    <div class="deco-circle deco-2"></div>
    <div class="deco-dots"></div>

    <div v-if="hasUser" class="content">
      <!-- 按钮区 -->
      <div class="actions">
        <div class="action-btn" v-for="item in visibleMenuItems" :key="item.key"
          @click="goTo(item.key)">
          <div class="btn-icon">
            <img :src="item.icon" alt="">
          </div>
          <span class="btn-title">{{ item.label }}</span>
          <span class="btn-arrow">&#8594;</span>
        </div>
      </div>

      <!-- 主视觉区 - 中间 -->
      <div class="hero">
        <div class="hero-graphic">
          <div class="hex-outer">
            <div class="hex-inner">
              <div class="hex-core"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="no-user">
      <h3>请添加用户信息ID</h3>
    </div>

    <div class="footer">
      <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="">
      <a href="https://beian.miit.gov.cn/" target="_blank">渝ICP备2021008364号-2</a>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import getuserName from '../../api/User'
import { parseHashParams } from '../../utils/params'

export default {
  data() {
    return {
      userData: null,
      query: null,
      hasUser: true,
    }
  },
  computed: {
    visibleMenuItems() {
      return [
        { key: 'model', class: 'tomodel', label: '三维模型', icon: '/static/images/model.png' },
      ].concat(
        this.hasUser ? [
          { key: 'pdf', class: 'toPDF', label: '重建报告', icon: '/static/images/hezi.png' },
        ] : []
      )
    },
  },
  created() {
    this.query = this.$route.query
    this.setQueryId(this.query)
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setQueryId']),

    async fetchUser() {
      const id = this.query.userId
      try {
        const res = await getuserName.Getnames(id)
        this.userData = res.data
        this.setUserInfo(res.data)
        this.validateUser()
      } catch (e) {
        this.hasUser = false
      }
    },

    validateUser() {
      const currentURL = this.$route.fullPath.substring(2)
      const parts = currentURL.split('&')
      const userId = parts[0]?.split('=')[1]
      const modelNum = parts[1]
      if (this.userData && modelNum) {
        this.hasUser = true
      } else {
        alert('没有查询到用户信息或者用户信息ID为空,请添加用户信息ID')
        this.hasUser = false
      }
    },

    goTo(key) {
      const params = parseHashParams()
      const id = params.modelNum || ''
      const routes = {
        model: `/ModulesLoding?userId=${id}&modelNum=${id}`,
        pdf: `/PDF?userId=${id}&modelNum=${id}`,
        dicom: '/DICOM',
        report: '/SurgicalPlanningReport',
        instruction: '/Instruction',
      }
      this.$router.push(routes[key] || '/')
    },
  },
  mounted() {
    this.fetchUser()
  },
}
</script>
<style scoped lang="scss">
// ===== 基础变量 =====
$blue: #2b7de9;
$blue-light: #5a9ff5;
$bg: #f2f5f9;

// ===== 容器 =====
.launch-container {
  width: 100vw;
  height: 100vh;
  background: $bg;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
}

// ===== 装饰 =====
.deco-circle {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba($blue, 0.08);
  pointer-events: none;
}
.deco-1 {
  width: 500px; height: 500px;
  top: -250px; right: -200px;
}
.deco-2 {
  width: 300px; height: 300px;
  bottom: -100px; left: -100px;
}
.deco-dots {
  position: absolute;
  top: 40px; right: 24px;
  width: 60px; height: 60px;
  pointer-events: none;
  background-image: radial-gradient(circle, rgba($blue, 0.12) 1.5px, transparent 1.5px);
  background-size: 12px 12px;
}

// ===== 内容 =====
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  z-index: 1;
  padding: 0;
}

// ===== 主视觉图形 - 居中 =====
.hero {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero-graphic {
  display: flex;
  align-items: center;
  justify-content: center;
}
.hex-outer {
  width: 80px; height: 80px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba($blue, 0.06) 0%, rgba($blue, 0.12) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(45deg);
}
.hex-inner {
  width: 44px; height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, $blue 0%, $blue-light 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba($blue, 0.25);
}
.hex-core {
  width: 10px; height: 10px;
  background: #fff;
  border-radius: 3px;
}

// ===== 按钮区 =====
.actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 20px;
  box-sizing: border-box;
}

.action-btn {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 22px 24px;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e8ecf2;
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color 0.25s, box-shadow 0.25s, transform 0.25s;

  &:hover {
    border-color: #b8d4f0;
    box-shadow: 0 4px 20px rgba(43, 125, 233, 0.1);
    transform: translateY(-2px);
    .btn-arrow { color: $blue; transform: translateX(3px); }
  }
  &:active { transform: scale(0.98); }
}

.btn-icon {
  width: 48px; height: 48px;
  min-width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eaf2fb 0%, #f4f7fc 100%);
  border-radius: 12px;
  img { width: 26px; height: 26px; }
}

.btn-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #1d2129;
  letter-spacing: 3px;
}

.btn-arrow {
  font-size: 20px;
  color: #d0d6de;
  min-width: 24px;
  text-align: right;
  transition: color 0.25s, transform 0.25s;
}

// ===== 无用户 =====
.no-user {
  position: relative;
  z-index: 1;
  text-align: center;
  h3 { color: #889; font-weight: 400; }
}

// ===== 底部 =====
.footer {
  width: 100vw;
  position: fixed;
  bottom: 12px;
  font-size: 12px;
  text-align: center;
  color: #b4bcc6;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  img { width: 15px; height: 15px; margin-right: 4px; opacity: 0.4; }
  a { color: #b4bcc6; text-decoration: none; }
}

// ===== 响应式: 平板 =====
@media (min-width: 600px) {
  .hex-outer { width: 96px; height: 96px; border-radius: 24px; }
  .hex-inner { width: 52px; height: 52px; border-radius: 14px; }
  .hex-core { width: 12px; height: 12px; }

  .actions { padding: 32px 28px; gap: 18px; }
  .action-btn { padding: 24px 28px; border-radius: 16px; }
  .btn-icon { width: 52px; height: 52px; min-width: 52px; border-radius: 14px; img { width: 28px; height: 28px; } }
  .btn-title { font-size: 19px; letter-spacing: 4px; }
}

// ===== 响应式: 桌面 =====
@media (min-width: 1024px) {
  .deco-1 { width: 700px; height: 700px; top: -350px; right: -280px; }
  .deco-2 { width: 450px; height: 450px; bottom: -150px; left: -150px; }
  .deco-dots { top: 60px; right: 60px; width: 80px; height: 80px; background-size: 14px 14px; }

  .hex-outer { width: 110px; height: 110px; border-radius: 28px; }
  .hex-inner { width: 60px; height: 60px; border-radius: 16px; }
  .hex-core { width: 14px; height: 14px; }

  .actions { padding: 40px 36px; gap: 20px; }
  .action-btn { padding: 26px 32px; border-radius: 18px; }
  .btn-icon { width: 56px; height: 56px; min-width: 56px; border-radius: 16px; img { width: 30px; height: 30px; } }
  .btn-title { font-size: 20px; letter-spacing: 5px; }
}
</style>
